<template>
  <div>
    <projectTable :operateColumns="operateColumns" :extraQuery="extraQuery">
      <Button slot="extraBtn" type="success" style="margin-left:10px;" @click="backMenu">返回菜单</Button>
      <span slot="extraBtn" style="margin-left:10px;font-size:14px;color:#ed4014;">已在OA上发起退保流程的请勿在此再次发起</span>
    </projectTable>
    <Modal v-model="orderSelectVisible" title="退保发起" width="1000">
      <div style="margin-bottom:5px;">
        <Checkbox v-model="notBiddingChoose" v-if="refundType==='未中标'">非中标全选</Checkbox>
        <Checkbox v-model="biddingChoose" v-if="refundType==='中标'">中标全选</Checkbox>
      </div>
      <Table :data="depositOrders" :columns="columns" @on-selection-change="orderSelectionChange"></Table>
      <div v-for="bidder in bidCompany" style="border-top:1px solid #ddd;margin-top:20px;">
        <div style="padding:5px 15px;">
          <span>中标单位：{{bidder.abpEnroll.companyName}}</span>
          <span style="margin-left:80px;">中标金额：{{bidder.winAmount}}</span>
          <span style="margin-left:80px;">中标包组：{{bidder.groupNumber}}</span>
          <span v-if="bidder.clGroupDb&&bidder.clGroupDb.isBuyer" style="color:#19be6b;">（采购人付款）</span>
        </div>
        <div v-if="bidder.serviceCharge&&bidder.serviceCharge.length>0" style="padding:5px 15px;">
          <!-- <span>服务费收取时间：{{bidder.serviceCharge.ordersDto.payTime | filterTime}}</span>
          <span style="margin-left:65px;">服务费收取金额：{{bidder.serviceCharge.ordersDto.orderAmountTotal}}</span>
          <span style="margin-left:65px;">合同存档日期：{{bidder.serviceCharge.pactTime | filterTime}}</span> -->
          <template v-for="serviceCharge in bidder.serviceCharge">
            <div style="display:flex">
              <span>服务费收取时间：{{serviceCharge.ordersDto.payTime | filterTime}}</span>
              <span style="margin-left:65px;">服务费收取金额：{{serviceCharge.ordersDto.orderAmountTotal}}</span>
              <span>
                <p>
                  <span style="margin-left:65px;">合同存档日期：{{serviceCharge.pactTime | filterTime}}</span>
                  <Button type="primary" size="small" style="margin-left:16px;" @click="setPactDate(serviceCharge, 0)">录入合同存档日期</Button>
                </p>
                <p style="margin-top:10px">
                  <span style="margin-left:65px;">合同签订日期：{{serviceCharge.pactSigningTime | filterTime}}</span>
                  <Button type="primary" size="small" style="margin-left:16px;" @click="setPactDate(serviceCharge, 1)">录入合同签订日期</Button>
                </p>
              </span>
            </div>
          </template>
        </div>
      </div>
      <div style="margin-top:16px;" v-if="bidServiceCharge.length>0">
        <span>采购人付款服务费<span style="color:#ff9900;">（请填写合同存档日期，否则审核无法通过）</span></span>
        <div v-for="serviceCharge in bidServiceCharge" style="border-top:1px solid #ddd;margin-bottom:20px;padding:5px 15px;">
          <div>
            <span>公司名称：{{serviceCharge.companyName}}</span>
            <span style="margin-left:65px;">信用代码：{{serviceCharge.companyNo}}</span>
          </div>
          <div style="display:flex">
            <span>服务费收取时间：{{serviceCharge.ordersDto.payTime | filterTime}}</span>
            <span style="margin-left:65px;">服务费收取金额：{{serviceCharge.ordersDto.orderAmountTotal}}</span>
            <span>
              <p>
                <span style="margin-left:65px;">合同存档日期：{{serviceCharge.pactTime | filterTime}}</span>
                <Button type="primary" size="small" style="margin-left:16px;" @click="setPactDate(serviceCharge, 0)">录入合同存档日期</Button>
              </p>
              <p style="margin-top:10px">
                <span style="margin-left:65px;">合同签订日期：{{serviceCharge.pactSigningTime | filterTime}}</span>
                <Button type="primary" size="small" style="margin-left:16px;" @click="setPactDate(serviceCharge, 1)">录入合同签订日期</Button>
              </p>
            </span>
          </div>
        </div>
      </div>
      <div slot="footer">
        <Button @click="orderSelectVisible=false">取消</Button>
        <Button type="primary" @click="createRefundMargin">确定</Button>
      </div>
    </Modal>
    <Modal :title="'合同'+(timeType?'签订':'存档')+'日期'" v-model="setPactDateVisible">
      <div v-if="timeType" style="margin-bottom:10px">
        <span>是否有签订日期：</span>
        <RadioGroup v-model="hasSigningTime">
          <Radio label="是"></Radio>
          <Radio label="否"></Radio>
        </RadioGroup>
      </div>
      <div>
        <span>合同{{timeType?'签订':'存档'}}日期：</span>
        <DatePicker type="date" placeholder="选择时间" style="width: 200px" v-model="pactTime"></DatePicker>
      </div>
      <div slot="footer">
        <Button @click="setPactDateVisible=false">取消</Button>
        <Button @click="setPactDateConfirm" type="primary">确定</Button>
      </div>
    </Modal>
    <Modal
      title="发起退保流程"
      v-model="depositFlowVisible"
      width="1000"
    >
      <deposit-flow-start
        ref="flowStart"
        :flowMargin="flowMargin"
        :uploadFileInit="uploadFileInit"
        @flowStartFinish="flowStartFinish"
      ></deposit-flow-start>
      <div slot="footer">
        <Button @click="depositFlowVisible=false">取消</Button>
        <Button
          type="primary"
          @click="startFlow"
        >确定</Button>
      </div>
    </Modal>
    <Modal title="退保类型" v-model="refundTypeVisible">
      <RadioGroup type="button" v-model="refundType">
        <Radio label="未中标">退保（未中标）</Radio>
        <Radio label="中标">退保（中标）</Radio>
      </RadioGroup>
      <div slot="footer">
        <Button @click="refundTypeVisible=false">取消</Button>
        <Button type="primary" @click="selectRefundType">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import ProjectTable from '@/components/projectTable'
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'
import { fileUtil } from '@/lib/abpfile'
import DepositFlowStart from './depositFlowStart'
import { formatDate } from '@/lib/tool'

const fileType = 1
const bucket = 'chinapsp-yw'
const dir = 'deposit/'

export default {
  name: 'depositBackMerge',
  components: {
    ProjectTable,
    DepositFlowStart
  },
  data() {
    return {
      operateColumns: [
        {
          title: '操作',
          width: 200,
          render: (h, params) => {
            return [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    const projectData = params.row
                    // 限制进入4.0立项
                    if (projectData.dataSource === '4.0立项' && projectData.projectFull !== 'CLF0123GZ03QY09') {
                      this.$Modal.confirm({
                        title: '温馨提示',
                        content: '退保证金申请功能已转移到采联业务系统4.0，请到业务系统4.0【退保流程】处使用该功能。',
                        cancelText: '取消',
                        okText: '立即前往',
                        onOk: () => {
                          if (isWeiXin()) {
                            window.open('https://qy.choicelink.cn:8440?wxWork=1&tenancyName=clgj&authProvider=CailianBusiness&appName=WorkWeiXin')
                          } else {
                            window.open('https://qy.choicelink.cn:8440')
                          }
                        }
                      })
                        return
                     }
                    this.refundType = '未中标'
                    this.selectProject = params.row
                    // this.refundTypeVisible = true
                    // this.notBiddingChoose = false
                    // this.biddingChoose = false
                    // this.showDeposit()
                    this.selectRefundType()
                  }
                }
              }, '退保(未中标)'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginLeft: '5px'
                },
                on: {
                  click: () => {
                    const projectData = params.row
                    // 限制进入4.0立项
                    if (projectData.dataSource === '4.0立项' && projectData.projectFull !== 'CLF0123GZ03QY09') {
                      this.$Modal.confirm({
                        title: '温馨提示',
                        content: '退保证金申请功能已转移到采联业务系统4.0，请到业务系统4.0【退保流程】处使用该功能。',
                        cancelText: '取消',
                        okText: '立即前往',
                        onOk: () => {
                          if (isWeiXin()) {
                            window.open('https://qy.choicelink.cn:8440?wxWork=1&tenancyName=clgj&authProvider=CailianBusiness&appName=WorkWeiXin')
                          } else {
                            window.open('https://qy.choicelink.cn:8440')
                          }
                        }
                      })
                        return
                     }
                    this.refundType = '中标'
                    this.selectProject = params.row
                    // this.refundTypeVisible = true
                    // this.notBiddingChoose = false
                    // this.biddingChoose = false
                    // this.showDeposit()
                    this.selectRefundType()
                  }
                }
              }, '退保(中标)')
            ]
          }
        }
      ],
      extraQuery: {
        status: ' and (projectState == "已挂网文件售卖中" or projectState == "项目失败" or projectState == "已开评标完" or projectState == "项目结项")',
      },
      selectProject: {},
      orderSelectVisible: false,
      depositOrders: [],
      columns: [
        {
          type: 'selection',
          width: 55,
          align: 'center'
        },
        {
          title: '报名供应商',
          key: 'ghfCompanyName'
        },
        {
          title: '汇款单位',
          render: (h, params) => {
            return h('div', params.row.abpOrdersExp.bankName)
          }
        },
        {
          title: '包组',
          width: 65,
          render: (h, params) => {
            return h('div', params.row.abpOrdersExp.clGroupDb.groupNo)
          }
        },
        {
          title: '中标',
          key: 'isBidding',
          width: 65
        },
        {
          title: '领取金额',
          key: 'orderAmountTotal',
          width: 110,
        },
        {
          title: '收取时间',
          key: 'payTime',
          width: 110,
          render: (h, params) => {
            let time = ''
            if (params.row.payTime) {
              time = params.row.payTime.split('T')[0]
            }
            return h('div', time)
          }
        },
        {
          title: '审核',
          width: 85,
          render: (h, params) => {
            let status = '未发起'
            let statusColor = '#495060'
            if (params.row.flowStatus === '1') {
              status = '审核中'
              statusColor = '#ff9900'
            }
            if (params.row.flowStatus === '2') {
              status = '通过'
              statusColor = '#19be6b'
            }
            return h('div', {
              style: {
                color: statusColor
              }
            }, status)
          }
        },
        {
          title: '已退',
          width: 85,
          render: (h, params) => {
            let isRefund = '是'
            let statusColor = '#19be6b'
            if (params.row.orderStatus === '2') {
              isRefund = '否'
              statusColor = '#ed4014'
            }
            return h('div', {
              style: {
                color: statusColor
              }
            }, isRefund)
          }
        },
      ],
      bidCompany: [],
      notBiddingChoose: false,
      biddingChoose: false,
      depositFlowVisible: false,
      uploadFileInit: {
        action: '',
        extradata: {}
      },
      flowMargin: [],
      refundTypeVisible: false,
      refundType: '',
      setPactDateVisible: false,
      selectServiceCharge: '',
      pactTime: '',
      // copyOrderList: []
      bidServiceCharge: [],
      timeType: 0, // 0 存档日期 1 签订日期
      hasSigningTime: ''
    }
  },
  computed: {
    user() {
      return this.$store.state.session.user
    }
  },
  methods: {
    setPactDate(serviceCharge, type) {
      this.timeType = type
      this.selectServiceCharge = serviceCharge
      this.setPactDateVisible = true
    },
    async setPactDateConfirm() {
      if (!this.pactTime && this.hasSigningTime !== '否') {
        this.$Message.info('请选择日期')
        return
      }
      try {
        this.$Spin.show()
        let params = {
          id: this.selectServiceCharge.id,
          pactNo: this.selectServiceCharge.pactNo,
          amount: this.selectServiceCharge.amount,
          marginReturnTime: this.selectServiceCharge.marginReturnTime,
          comment: this.selectServiceCharge.comment,
          hasSigningTime: this.hasSigningTime === '是' ? true : false
        }
        if (this.timeType) {
          Object.assign(params, {
            pactSigningTime: params.hasSigningTime ? formatDate(this.pactTime) : '',
            pactTime: this.selectServiceCharge.pactTime
          })
        } else {
          Object.assign(params, {
            pactSigningTime: this.selectServiceCharge.pactSigningTime,
            pactTime: formatDate(this.pactTime)
          })
        }
        let rep = await ajax.post(requestUrls.AbpServiceCharge.ServiceRepair, params)
        this.$Spin.show()
        if (rep.data.success) {
          this.$Message.success('调整成功')
          // 刷新
          this.setPactDateVisible = false
          this.showDeposit()
        } else {
          this.$Message.error('操作失败')
        }
      } catch(err) {
        this.$Message.error('操作失败')
        console.error(err)
      }
    },
    selectRefundType() {
      if (this.refundType === '') {
        this.$Message.info('请选择退款类型')
        return
      }
      this.refundTypeVisible = false
      this.notBiddingChoose = false
      this.biddingChoose = false
      this.showDeposit()
    },
    backMenu() {
      this.$emit('return', false)
    },
    async getEnrollExt(projectId = '') {
      let rep = await ajax.get(requestUrls.enroll.GetEnrollExt, {
        params: {
          pid: projectId
        }
      })
      if (rep.data.success) {
        return rep.data.result.items
      }
      return []
    },
    async getDepositOrder(projectId = '000') {
      let filter = `projectId == "${projectId}" and orderType == "保证金"`
      let rep = await ajax.get(requestUrls.order.getPaged, {
        params: {
          filter: filter,
          sorting: '',
          maxResultCount: 1000,
          skipCount: 0,
        }
      })
      if (rep.data.success) {
        return rep.data.result.items
      }
      return []
    },
    async refreshOrders() {

      let orderList = await this.getDepositOrder(this.selectProject.id)
      this.depositOrders = []
      let orderLength = orderList.length
      while (orderList.length > 0) {
        let order = orderList.pop()
        orderLength--
        // 中标检查
        order.isBidding = '否'
        for (let j = 0; j < this.bidCompany.length; j++) {
          if (order.ghfCompanyName === this.bidCompany[j].abpEnroll.companyName && order.abpOrdersExp.groupId === this.bidCompany[j].groupId) {
            order.isBidding = '是'
            this.bidCompany[j].clGroupDb = order.abpOrdersExp.clGroupDb
            break
          }
        }

        // 除了2状态都不可选（已经退）
        if (order.orderStatus !== '2') {
          order._disabled = true
        }

        // 流程状态1，2都未已发起状态，不可选
        if (order.flowStatus === '1' || order.flowStatus === '2') {
          order._disabled = true
        }

        // 过滤中标类型
        if (this.refundType === '中标' && order.isBidding === '是') {
          this.depositOrders.push(order)
        }
        if (this.refundType === '未中标' && order.isBidding === '否') {
          this.depositOrders.push(order)
        }
      }
      // this.copyOrderList = JSON.parse(JSON.stringify(this.depositOrders))
    },
    async showDeposit() {
      this.$Spin.show()
      // 获取中标信息（报名附属表）
      let enrollList = await this.getEnrollExt(this.selectProject.id)
      this.bidCompany = []
      // 中标过滤
      enrollList.forEach(enroll => {
        if (enroll.status) {
          this.bidCompany.push(enroll)
        }
      })
      await this.refreshOrders()

      await this.resortBidService(this.selectProject.id)
      
      this.$Spin.hide()
      this.orderSelectVisible = true
    },
    // 获取已收取服务费
    async getReceiveFee(projectId = '00') {
      let rep = await ajax.get(requestUrls.AbpServiceCharge.getPaged, {
        params: {
          filter: `s.projectId == "${projectId}"`,
          maxResultCount: 1000,
          skipCount: 0,
        }
      })
      if (rep.data.success) {
        return rep.data.result.items
      }
      return []
    },
    // 中标单位及服务费归类
    async resortBidService(projectId = '00') {
      let serviceCharges = await this.getReceiveFee(projectId)
      this.bidServiceCharge = []
      serviceCharges.forEach(serviceCharge => {
        if (serviceCharge.isBuyer && serviceCharge.status === '1') {
          this.bidServiceCharge.push(serviceCharge)
        }
      })
      this.bidCompany.forEach(bidder => {
        for (let i = 0; i < serviceCharges.length; i++) {
          const serviceCharge = serviceCharges[i]
          if (serviceCharge.status === '1' && serviceCharge.groupId === bidder.groupId && serviceCharge.companyName === bidder.abpEnroll.companyName) {
            let services = []
            if (bidder.serviceCharge && bidder.serviceCharge.length > 0) {
              services = services.concat(bidder.serviceCharge, [serviceCharge])
              // services.push(serviceCharge)
            } else {
              services.push(serviceCharge)
            }
            this.$set(bidder, 'serviceCharge', services)
          }
        }
      })
    },
    async createRefundMargin() {
      this.flowMargin = []
      this.depositOrders.forEach(order => {
        if ((order.isChecked || order._checked) && !order._disabled) {
          delete order.dbFile
          this.flowMargin.push(order)
        }
      })
      if (this.flowMargin.length === 0) {
        this.$Message.info('至少选择一个发起退保申请')
        return
      }
      let hasServiceCharge = true
      let hasPactTime = true
      this.flowMargin.forEach(margin => {
        if (margin.isBidding === '是') {
          for(let i = 0; i < this.bidCompany.length; i++) {
            const bidder = this.bidCompany[i]
            if (bidder.abpEnroll.companyName === margin.ghfCompanyName && bidder.groupId === margin.abpOrdersExp.groupId && !margin.abpOrdersExp.clGroupDb.isBuyer) {
              if (!bidder.serviceCharge || bidder.serviceCharge.length === 0) {
                hasServiceCharge = false
              } else {
                for (let j = 0; j < bidder.serviceCharge.length; j++) {
                  const service = bidder.serviceCharge[j]
                  if (!service.pactTime || new Date(service.pactTime) === 'Invalid Date') {
                    hasPactTime = false
                  }
                }
              }
            } else if (margin.abpOrdersExp.clGroupDb.isBuyer && this.bidServiceCharge.length === 0) {
              hasServiceCharge = false
            }
          }
        }
      })
      if (!hasServiceCharge) {
        this.$Message.info('未录入服务费不可退中标供应商保证金')
        return
      }
      if (!hasPactTime) {
        this.$Message.info('未录入合同日期')
        return
      }
      this.$Spin.show()
      // 初始化上查
      this.uploadFileInit = await fileUtil.downloadInit(this.user.id, fileType, bucket, dir)
      this.$Spin.hide()
      this.depositFlowVisible = true
    },
    flowStartFinish() {
      this.depositFlowVisible = false
      // 刷新订单
      this.refreshOrders()
    },
    startFlow() {
      this.$refs.flowStart.getFlowUser()
    },
    orderSelectionChange(selection) {
      // 添加字段，为了识别中标全选和非中标权限问题
      this.depositOrders.forEach(order => {
        order.isChecked = false
        order._checked = false
        for (let i = 0; i < selection.length; i++) {
          if (order.id === selection[i].id) {
            order.isChecked = true
            order._checked = true
            break
          }
        }
      })

      // for (let i = 0; i < this.depositOrders.length; i++) {
      //   const order = this.depositOrders[i]
      //   order.isChecked = false
      //   order._checked = false
      //   for (let j = 0; j < selection.length; j++) {
      //     if (order.id === selection[j].id) {
      //       order.isChecked = true
      //       order._checked = true
      //       break
      //     }
      //   }
      // }

    }
  },
  watch: {
    notBiddingChoose(val) {
      this.depositOrders.forEach(order => {
        if (order.isBidding === '否') {
          this.$set(order, '_checked', val)
          this.$set(order, 'isChecked', val) // 防止选择了没清空
        }
      })
    },
    biddingChoose(val) {
      this.depositOrders.forEach(order => {
        if (order.isBidding === '是') {
          this.$set(order, '_checked', val)
          this.$set(order, 'isChecked', val) // 防止选择了没清空
        }
      })
    }
  },
  filters: {
    filterTime(val) {
      if (!val) {
        return '-'
      }
      return formatDate(val)
    },
  }
}
</script>
